<section id="our-services" class="services">
  <div class="services__container">
    <div class="services__header" appScrollAnimate [animationDelay]="0" [threshold]="0.3">
      <div class="services__header-left">
        <p class="services__subtitle">SERVICES</p>
        <h2 class="services__title">What We Do</h2>
      </div>
      <div class="services__divider"></div>
      <p class="services__description">Professional flooring services tailored to transform your space with quality craftsmanship and attention to detail.</p>
    </div>

    <div class="services__list">
      @for (service of services; track $index) {
        <article class="services__item service-item" [class.service-item--reverse]="$index % 2 !== 0">
          <div class="service-item__image"
               [class.slide-from-left]="$index % 2 === 0"
               [class.slide-from-right]="$index % 2 !== 0"
               appScrollAnimate
               [animationDelay]="100"
               [threshold]="0.2">
            <img [src]="service.image" [alt]="service.title" class="service-item__img" [class.service-item__img--bottom]="$index === 1">
          </div>
          <div class="service-item__content"
               [class.slide-from-right]="$index % 2 === 0"
               [class.slide-from-left]="$index % 2 !== 0"
               appScrollAnimate
               [animationDelay]="200"
               [threshold]="0.2">
            <h3 class="service-item__title">{{ service.title }}</h3>
            <p class="service-item__text">{{ service.text }}</p>
            <ul class="service-item__list">
              @for (point of service.bulletPoints; track $index) {
                <li class="service-item__list-item">{{ point }}</li>
              }
            </ul>
            <div class="service-item__booking">
              <button class="service-item__button" (click)="bookService(service.serviceId)">BOOK {{ service.bookingName | uppercase }}</button>
            </div>
          </div>
        </article>

        @if ($index === 1) {
          <div class="services__included-notice">
            <div class="services__included-divider"></div>
            <p class="services__included-text">
              When you book Floor Sanding, the following services are included in the package:
            </p>
            <div class="services__included-divider"></div>
          </div>
        }
      }
    </div>

   <!-- <div class="services__button-wrapper">
      <button class="services__button">BOOK APPOINTMENT</button>
    </div>-->
  </div>
</section>
